module.exports = __webpack_public_path__ + "img/watch-2.79b561e9.jpg";